import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';

const RedirectToMobileScreen =  withRouter(({ location }: RouteComponentProps) =>
  <Redirect to={{ pathname: '/mobile', search: `?redirect=${location.pathname}` }} />
);

export default RedirectToMobileScreen;
